import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { InstitutionFragment } from 'generated/resources/graphql'

import { useCallback } from 'modules/core/hooks/useCallback'

import { ImageBox } from './imageBox'

interface InstitutionCardProps {
  onSelect: (institutionId: string) => void
  selected: boolean
  institution: InstitutionFragment
}

export const InstitutionCard = ({ institution, onSelect, selected }: InstitutionCardProps) => {
  const { name, logo, id, transactionTotalDays } = institution
  const [hover, setHover] = useState(false)

  const toggleHover = useCallback(() => {
    setHover((h) => !h)
  }, [])

  return (
    <Box
      border={{
        all: {
          color: selected ? 'grey800' : hover ? 'grey600' : 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs016' }}
      gridColSpan={{
        xs: 4,
        m: 4,
        l: 4,
        xl: 4,
        xxl: 4,
        xxs: 4,
        s: 4,
      }}
      flexDirection="column"
      alignItems="center"
      justifyContent="spaceBetween"
      paddingX="s8"
      paddingY="s16"
      onClick={() => onSelect(id)}
      cursor="pointer"
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      style={{ height: '165px' }}
    >
      <ImageBox url={logo} name={name + ' (' + transactionTotalDays + ')'} />
      <Box
        width="full"
        textAlign="center"
        flexDirection="column"
        justifyContent="flexEnd"
        height="s48"
      >
        <Text.Normal ellipsis size="300" weight="semibold" lineClamp={2}>
          {name}
        </Text.Normal>
      </Box>
    </Box>
  )
}
